<script lang="ts">
	import { onMount } from 'svelte';
	import { Card, Select, Label, Spinner } from 'flowbite-svelte';
	import PageHeader from '../../components/PageHeader.svelte';
	import ProbeMetricsView from '../../components/admin/ProbeMetricsView.svelte';
	import { listProbes } from '../../AppNetwork';
	import type { Probe } from '../../AppTypes';

	let probes: Probe[] = [];
	let selectedProbeId: number | null = null;
	let loading = true;
	let error = '';

	async function init() {
		loading = true;
		error = '';
		try {
			probes = (await listProbes({ limit: 200 })).items;
			if (probes.length > 0) {
				selectedProbeId = probes[0].id;
			}
		} catch (e) {
			error = e instanceof Error ? e.message : 'Failed to load probes';
		} finally {
			loading = false;
		}
	}
	onMount(init);
</script>

<PageHeader title="Metrics" description="Filter and range-filter probe metrics and view them as plots." />

<div class="space-y-6">
	<Card class="max-w-none">
		<div class="min-w-[220px]">
			<Label class="mb-1">Probe</Label>
			<Select value={selectedProbeId} on:change={(e) => (selectedProbeId = Number(e.currentTarget.value))}>
				{#each probes as probe}<option value={probe.id}>{probe.name}</option>{/each}
			</Select>
		</div>
	</Card>

	{#if loading}
		<div class="flex justify-center py-12"><Spinner size="8" /></div>
	{:else if error}
		<Card class="max-w-none"><p class="text-red-500 text-center py-4">{error}</p></Card>
	{:else if probes.length === 0}
		<Card class="max-w-none"><p class="text-gray-400 text-center py-8">No probes yet — create a probe first.</p></Card>
	{:else if selectedProbeId !== null}
		<ProbeMetricsView probeId={selectedProbeId} />
	{/if}
</div>
